import 'imports-loader?$=jquery,this=>window!messenger/build/js/messenger';
const {
    Messenger
} = window;
export const notificationMixin = {
    methods: {
        initializationMessengerCode() {
            (function () {
                let $,
                    FlatMessage,
                    spinner_template,
                    __hasProp = {}.hasOwnProperty,
                    __extends = function (child, parent) {
                        for (const key in parent) {

                            if (__hasProp.call(parent, key)) child[key] = parent[key];
                        }

                        function ctor() {
                            this.constructor = child;
                        }
                        ctor.prototype = parent.prototype;
                        child.prototype = new ctor();
                        child.__super__ = parent.prototype;
                        return child;
                    };
                $ = jQuery;
                spinner_template =
                    '<div class="messenger-spinner">\n    <span class="messenger-spinner-side messenger-spinner-side-left">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n    <span class="messenger-spinner-side messenger-spinner-side-right">\n        <span class="messenger-spinner-fill"></span>\n    </span>\n</div>';
                FlatMessage = (function (_super) {
                    __extends(FlatMessage, _super);

                    function FlatMessage() {

                        setTimeout(() => {
                            $(".messenger-theme-air").addClass("messenger-empty-animation");

                        }, 2500)
                        setTimeout(() => {
                            $(".messenger-theme-air").addClass("messenger-empty");
                            $(".messenger-will-hide-after").addClass("messenger-hidden");
                            $(".messenger-theme-air").removeClass("messenger-empty-animation");
                        }, 3000)
                        return FlatMessage.__super__.constructor.apply(this, arguments);
                    }
                    FlatMessage.prototype.template = function (opts) {

                        let $message;
                        $message = FlatMessage.__super__.template.apply(this, arguments);
                        $message.append($(spinner_template));
                        return $message;
                    };

                    return FlatMessage;
                }(Messenger.Message));
                Messenger.themes.air = {
                    Message: FlatMessage,
                };

            }).call(window);
        }
    }
}